import recipients from "@/store/app/office/settings/recipients"

export default {
  namespaced: true,

  actions: {},

  modules: {
    recipients,
  }
}
